import type { AppRoute } from "../../../navigation/routes";
import {
  Activity,
  Heart,
  Brain,
  Wrench,
  HeartHandshake,
  Compass,
} from "lucide-react";
export const dimensions = [
  {
    key: "body",
    route: "wellness" as AppRoute,
    related: ["health", "fitness", "nutrition"] as AppRoute[],
    hint: "运动、饮食与健康",
    glyph: "身",
    name: "身体状态",
    icon: Activity,
    color: "var(--dimension-body, #4ade80)",
    background: "var(--dimension-body-bg, #4ade8018)",
  },
  {
    key: "heart",
    route: "mind" as AppRoute,
    related: ["energy"] as AppRoute[],
    hint: "觉察情绪，照顾内心",
    glyph: "心",
    name: "内心状态",
    icon: Heart,
    color: "var(--dimension-heart, #f472b6)",
    background: "var(--dimension-heart-bg, #f472b618)",
  },
  {
    key: "intellect",
    route: "intellect" as AppRoute,
    related: ["exam", "mbti"] as AppRoute[],
    hint: "读过、学过与想过",
    glyph: "智",
    name: "知识学习",
    icon: Brain,
    color: "var(--dimension-intellect, #60a5fa)",
    background: "var(--dimension-intellect-bg, #60a5fa18)",
  },
  {
    key: "craft",
    route: "pathway" as AppRoute,
    related: [] as AppRoute[],
    hint: "练习、作品与进步",
    glyph: "技",
    name: "技能成长",
    icon: Wrench,
    color: "var(--dimension-craft, #22d3ee)",
    background: "var(--dimension-craft-bg, #22d3ee18)",
  },
  {
    key: "bond",
    route: "people" as AppRoute,
    related: ["person", "pan-spirit"] as AppRoute[],
    hint: "相遇、陪伴与联结",
    glyph: "缘",
    name: "人际关系",
    icon: HeartHandshake,
    color: "var(--dimension-bond, #fbbf24)",
    background: "var(--dimension-bond-bg, #fbbf2418)",
  },
  {
    key: "purpose",
    route: "goals" as AppRoute,
    related: [] as AppRoute[],
    hint: "目标、选择与方向",
    glyph: "志",
    name: "人生方向",
    icon: Compass,
    color: "var(--dimension-purpose, #a78bfa)",
    background: "var(--dimension-purpose-bg, #a78bfa18)",
  },
] as const;
export type DimensionKey = (typeof dimensions)[number]["key"];
export const dimensionFor = (key: string) =>
  dimensions.find((d) => d.key === key) || dimensions[0];
